export default __webpack_public_path__ + "static/media/Total-environment-Bengaluru-international-airport.5f4528cd.jpg";